import { types } from 'mobx-state-tree'

const mainPageResourceModal = types.model('mainPageResourceModal', {
  id: types.optional(types.integer, 0),
  name: types.maybeNull(types.string),
  mainFilePath: types.maybeNull(types.string, ''),
  author: types.maybeNull(types.string),
})

export default mainPageResourceModal
